import { Component, OnInit, Input } from '@angular/core';
import { ProductGroup } from '@app/core/models/client';
import { NgStyle, NgClass } from '@angular/common';
import { BubbleComponent } from '../../../../shared/bubble/bubble.component';

@Component({
    selector: 'two-way-preview',
    templateUrl: './two-way-preview.component.html',
    styleUrls: ['./two-way-preview.component.scss'],
    standalone: true,
    imports: [NgStyle, NgClass, BubbleComponent]
})
export class TwoWayPreviewComponent implements OnInit {
    @Input() messageText: string;
    @Input() productGroup: ProductGroup;

    constructor() {}

    ngOnInit() {
    }
}
